import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { isEmpty } from 'lodash';
import { getData } from '../../../store/AppMaster/actions';
import api from '../../../constants/api_constants';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import messageConstant from '../../../constants/message';
import { addUpdateNewData } from '../../../store/AppMaster/actions';
import regex from '../../../constants/regex';
import { pushClickBusinessFormSubmit } from '../../../seo/gtevents';
const useBusinessData = (props) => {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => ({
    data: state.AppMaster.data,
  }));
  const { successMessage } = useSelector((state) => ({
    successMessage: state.AppMaster.success,
  }));
  const [openAccordion, setOpenAccordion] = useState(null);
  const [openIndex, setOpenIndex] = useState(null);
  const [activeCard, setActiveCard] = useState(0);
  const [startCount, setStartCount] = useState(false);
  const [isApiCalled, setIsApiCalled] = useState(0);
  const [countData, setCountData] = useState('');
  const sectionRef = useRef(null);

  const toggleAccordion = (accordionId) => {
    setOpenAccordion(openAccordion === accordionId ? null : accordionId);
  };

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleCardClick = (index) => {
    if (activeCard !== index) {
      setActiveCard(index);
    }
  };

  useEffect(() => {
    if (isApiCalled === 0) {
      setIsApiCalled(true);
      const requestData = {};
      dispatch(
        getData(requestData, props.router.navigate, api.BUSINESS_PAGE_COUNT),
      );
    }
  }, [dispatch, isApiCalled]);

  useEffect(() => {
    if (
      !isEmpty(data) &&
      !isEmpty(data.bussiness_count) &&
      isEmpty(countData)
    ) {
      setCountData(data.bussiness_count);
    }
  }, [data, countData]);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setStartCount(true); // Start the counter when the section is in view
          observer.disconnect(); // Stop observing after it starts
        }
      },
      {
        threshold: 0.5, // Trigger when 50% of the section is visible
      },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (observer && sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  const [isUpdateFormData, setIsUpdateFormData] = useState(false);
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: '',
      mobile: '',
      email: '',
      company_name: '',
    },
    validationSchema: Yup.object({
      name: Yup.string()
        .required(messageConstant.FULL_NAME_REQUIRED)
        .min(regex.NAME_MIN, messageConstant.FULL_NAME_MIN_LENGTH)
        .max(regex.NAME_MAX, messageConstant.FULL_NAME_MAX_LENGTH),
      mobile: Yup.string()
        .required(messageConstant.MOBILE_REQUIRED)
        .matches(/^[0-9]+$/, messageConstant.MOBILE_INVALID)
        .min(10, messageConstant.MOBILE_MIN_LENGTH)
        .max(10, messageConstant.MOBILE_MAX_LENGTH),
      email: Yup.string()
        .required(messageConstant.EMAIL_REQUIRED)
        .email(messageConstant.EMAIL_INVALID),
      company_name: Yup.string().required(
        messageConstant.COMPANY_NAME_REQUIRED,
      ),
    }),
    onSubmit: (values) => {
      setIsUpdateFormData(true);
      const requestData = {
        name: values.name,
        mobile: values.mobile,
        email: values.email,
        company_name: values.company_name,
      };
      pushClickBusinessFormSubmit(requestData);
      dispatch(
        addUpdateNewData(
          requestData,
          props.router.navigate,
          api.SEND_BUSINESS_EMAIL,
        ),
      );
    },
  });

  if (!isEmpty(data) && data.emailSend && isUpdateFormData) {
    setIsUpdateFormData(false);
    validation.resetForm();
  }

  const schemaData = {
    type: 'Business',
    name: 'Business',
  };
  return {
    data,
    openAccordion,
    toggleAccordion,
    openIndex,
    handleToggle,
    activeCard,
    handleCardClick,
    startCount,
    sectionRef,
    countData,
    validation,
    setStartCount,
    successMessage,
    isUpdateFormData,
    schemaData,
  };
};

export default useBusinessData;
